import { constant } from '@cpc/comment-sdk-common';
import { useGlobalState, useNativeAbility } from '@cpc/comment-sdk-core-comment';

export const commonTopicStat = (categoryCode: number, actCode: number, log_map = {}) => {
  const globalState = useGlobalState();
  const openSource
    = globalState.pageType === constant.PageType.DEFAULT
      ? 'article'
      : globalState.documentMeta.styleType === 2
        ? 'shortV'
        : globalState.documentMeta.styleType === 4
          ? 'smallV'
          : 'comment';
  const extra = {
    module: 101,
    openSource,
  };

  log_map = Object.assign(log_map, extra);

  console.log(
    '通用核心行为埋点: \n埋点大类：',
    categoryCode,
    ';\n埋点事件ID：',
    actCode,
    ';\n埋点字段：',
    JSON.stringify(log_map),
  );

  const { invoke } = useNativeAbility();

  invoke('SDKBrowserStat.commonStat', [actCode, categoryCode, JSON.stringify(log_map)]);
};

export const commonCommentStat = (name: number, params = {}) => {
  const category = 10012;
  const { invoke } = useNativeAbility();

  invoke('SDKBrowserStat.commonStat', [name, category, JSON.stringify(params)]);
};
